// extracted by mini-css-extract-plugin
export var codeBlockWrapper = "DocsMarkdown-module--codeBlockWrapper--a62a7";
export var copyButton = "DocsMarkdown-module--copyButton--2d029";
export var copyButtonCopied = "DocsMarkdown-module--copyButtonCopied--aad37";
export var tableWrapper = "DocsMarkdown-module--tableWrapper--5fc51";
export var taskCheckbox = "DocsMarkdown-module--taskCheckbox--6ceb9";
export var taskItem = "DocsMarkdown-module--taskItem--1411c";
export var taskList = "DocsMarkdown-module--taskList--910d0";